import { render, staticRenderFns } from "./peopleManagement.vue?vue&type=template&id=7621cd82&scoped=true"
import script from "./peopleManagement.vue?vue&type=script&lang=js"
export * from "./peopleManagement.vue?vue&type=script&lang=js"
import style0 from "./peopleManagement.vue?vue&type=style&index=0&id=7621cd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621cd82",
  null
  
)

export default component.exports